import { core } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

interface State {
  selectedMetroArea?: core.MetroArea;
}

export const initialState: State = {
  selectedMetroArea: undefined,
};

export default function reducer(state: State = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.METRO_AREA_SELECTED: {
      const selectedMetroArea = payload as core.MetroArea;
      return {
        ...state,
        selectedMetroArea,
      };
    }
    default:
      return state;
  }
}
